import { render, staticRenderFns } from "./LinkAccount.vue?vue&type=template&id=0554fb56&scoped=true"
import script from "./LinkAccount.vue?vue&type=script&lang=js"
export * from "./LinkAccount.vue?vue&type=script&lang=js"
import style0 from "./LinkAccount.vue?vue&type=style&index=0&id=0554fb56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0554fb56",
  null
  
)

export default component.exports